
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import {
  ShoppingInvoiceModel,
  ShoppingInvoicePageSearchModel,
  ShoppingInvoiceSearchModel,
  ShoppingInvoiceAddModel,
  ShoppingInvoiceUpdateModel,
  IdsModel
} from '@/model/product/ShoppingInvoiceModel'
import {
  pageSearchShoppingInvoice,
  addShoppingInvoice,
  updateShoppingInvoice,
  removeShoppingInvoice,
  batchRemoveShoppingInvoice
} from '@/apis/product/shoppingInvoice'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { selectOptionFormat } from '@/utils/options'
import { InvoiceType } from '@/constant/options'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const invoiceTypeOptions = selectOptionFormat(InvoiceType.invoiceTypeOptions, t, InvoiceType.i18nKey)
    const searchStruct = [
      { prop: 'userName', label: t('shoppingInvoice.userName'), placeholder: t('shoppingInvoice.userNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'invoiceTitle', label: t('shoppingInvoice.invoiceTitle'), placeholder: t('shoppingInvoice.invoiceTitleP'), component: 'el-input', type: 'text', model: null },
      { prop: 'taxNumber', label: t('shoppingInvoice.taxNumber'), placeholder: t('shoppingInvoice.taxNumberP'), component: 'el-input', type: 'text', model: null },
      { prop: 'registeredAddress', label: t('shoppingInvoice.registeredAddress'), placeholder: t('shoppingInvoice.registeredAddressP'), component: 'el-input', type: 'text', model: null },
      { prop: 'registeredPhone', label: t('shoppingInvoice.registeredPhone'), placeholder: t('shoppingInvoice.registeredPhoneP'), component: 'el-input', type: 'text', model: null },
      { prop: 'bankName', label: t('shoppingInvoice.bankName'), placeholder: t('shoppingInvoice.bankNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'bankAccount', label: t('shoppingInvoice.bankAccount'), placeholder: t('shoppingInvoice.bankAccountP'), component: 'el-input', type: 'text', model: null },
      { prop: 'invoiceType', label: t('shoppingInvoice.invoiceType'), placeholder: t('shoppingInvoice.invoiceTypeP'), component: 'el-select', type: 'number', model: null, options: invoiceTypeOptions }
    ]

    const createStruct = [
      { prop: 'userName', label: t('shoppingInvoice.userName'), placeholder: t('shoppingInvoice.userNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'invoiceTitle', label: t('shoppingInvoice.invoiceTitle'), placeholder: t('shoppingInvoice.invoiceTitleP'), component: 'el-input', type: 'text', model: null },
      { prop: 'taxNumber', label: t('shoppingInvoice.taxNumber'), placeholder: t('shoppingInvoice.taxNumberP'), component: 'el-input', type: 'text', model: null },
      { prop: 'registeredAddress', label: t('shoppingInvoice.registeredAddress'), placeholder: t('shoppingInvoice.registeredAddressP'), component: 'el-input', type: 'text', model: null },
      { prop: 'registeredPhone', label: t('shoppingInvoice.registeredPhone'), placeholder: t('shoppingInvoice.registeredPhoneP'), component: 'el-input', type: 'text', model: null },
      { prop: 'bankName', label: t('shoppingInvoice.bankName'), placeholder: t('shoppingInvoice.bankNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'bankAccount', label: t('shoppingInvoice.bankAccount'), placeholder: t('shoppingInvoice.bankAccountP'), component: 'el-input', type: 'text', model: null },
      { prop: 'invoiceType', label: t('shoppingInvoice.invoiceType'), placeholder: t('shoppingInvoice.invoiceTypeP'), component: 'el-select', type: 'number', model: null, options: invoiceTypeOptions }
    ]

    const updateStruct = [
      { prop: 'userName', label: t('shoppingInvoice.userName'), placeholder: t('shoppingInvoice.userNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'invoiceTitle', label: t('shoppingInvoice.invoiceTitle'), placeholder: t('shoppingInvoice.invoiceTitleP'), component: 'el-input', type: 'text', model: null },
      { prop: 'taxNumber', label: t('shoppingInvoice.taxNumber'), placeholder: t('shoppingInvoice.taxNumberP'), component: 'el-input', type: 'text', model: null },
      { prop: 'registeredAddress', label: t('shoppingInvoice.registeredAddress'), placeholder: t('shoppingInvoice.registeredAddressP'), component: 'el-input', type: 'text', model: null },
      { prop: 'registeredPhone', label: t('shoppingInvoice.registeredPhone'), placeholder: t('shoppingInvoice.registeredPhoneP'), component: 'el-input', type: 'text', model: null },
      { prop: 'bankName', label: t('shoppingInvoice.bankName'), placeholder: t('shoppingInvoice.bankNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'bankAccount', label: t('shoppingInvoice.bankAccount'), placeholder: t('shoppingInvoice.bankAccountP'), component: 'el-input', type: 'text', model: null },
      { prop: 'invoiceType', label: t('shoppingInvoice.invoiceType'), placeholder: t('shoppingInvoice.invoiceTypeP'), component: 'el-select', type: 'number', model: null, options: invoiceTypeOptions }
    ]

    const shoppingInvoiceRole = {
      userName: [{ required: true, message: t('shoppingInvoice.userName').concat(t('common.isRequired')), trigger: 'blur' }],
      invoiceTitle: [{ required: true, message: t('shoppingInvoice.invoiceTitle').concat(t('common.isRequired')), trigger: 'blur' }],
      taxNumber: [{ required: true, message: t('shoppingInvoice.taxNumber').concat(t('common.isRequired')), trigger: 'blur' }],
      registeredAddress: [{ required: true, message: t('shoppingInvoice.registeredAddress').concat(t('common.isRequired')), trigger: 'blur' }],
      registeredPhone: [{ required: true, message: t('shoppingInvoice.registeredPhone').concat(t('common.isRequired')), trigger: 'blur' }],
      bankName: [{ required: true, message: t('shoppingInvoice.bankName').concat(t('common.isRequired')), trigger: 'blur' }],
      bankAccount: [{ required: true, message: t('shoppingInvoice.bankAccount').concat(t('common.isRequired')), trigger: 'blur' }],
      invoiceType: [{ required: true, message: t('shoppingInvoice.invoiceType').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      { prop: 'userName', label: t('shoppingInvoice.userName'), sortable: 'custom' },
      { prop: 'invoiceTitle', label: t('shoppingInvoice.invoiceTitle'), sortable: 'custom' },
      { prop: 'taxNumber', label: t('shoppingInvoice.taxNumber'), sortable: 'custom' },
      { prop: 'registeredAddress', label: t('shoppingInvoice.registeredAddress'), sortable: 'custom' },
      { prop: 'registeredPhone', label: t('shoppingInvoice.registeredPhone'), sortable: 'custom' },
      { prop: 'bankName', label: t('shoppingInvoice.bankName'), sortable: 'custom' },
      { prop: 'bankAccount', label: t('shoppingInvoice.bankAccount'), sortable: 'custom' },
      { prop: 'invoiceType', label: t('shoppingInvoice.invoiceType'), formatter: (row: ShoppingInvoiceModel) => { return invoiceTypeOptions.find(mt => mt.value === row.invoiceType)?.label }, sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: ShoppingInvoiceModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: ShoppingInvoiceModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as ShoppingInvoiceSearchModel,
      tableData: Array<ShoppingInvoiceModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'shoppingInvoice.edit',
        create: 'shoppingInvoice.create'
      },
      dialogFormVisible: false,
      shoppingInvoiceRole: shoppingInvoiceRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as ShoppingInvoiceAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as ShoppingInvoiceUpdateModel,
      editRow: {} as ShoppingInvoiceModel,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: ShoppingInvoicePageSearchModel = {
          userName: dataMap.searchFormModel.userName,
          invoiceTitle: dataMap.searchFormModel.invoiceTitle,
          taxNumber: dataMap.searchFormModel.taxNumber,
          registeredAddress: dataMap.searchFormModel.registeredAddress,
          registeredPhone: dataMap.searchFormModel.registeredPhone,
          bankName: dataMap.searchFormModel.bankName,
          bankAccount: dataMap.searchFormModel.bankAccount,
          invoiceType: dataMap.searchFormModel.invoiceType,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchShoppingInvoice(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        const createData: ShoppingInvoiceAddModel = {
          userName: dataMap.createModel.userName,
          invoiceTitle: dataMap.createModel.invoiceTitle,
          taxNumber: dataMap.createModel.taxNumber,
          registeredAddress: dataMap.createModel.registeredAddress,
          registeredPhone: dataMap.createModel.registeredPhone,
          bankName: dataMap.createModel.bankName,
          bankAccount: dataMap.createModel.bankAccount,
          invoiceType: dataMap.createModel.invoiceType
        }
        const result = await addShoppingInvoice(createData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async updateNameSubmit() {
        const updateData: ShoppingInvoiceUpdateModel = {
          id: dataMap.updateModel.id,
          userName: dataMap.updateModel.userName,
          invoiceTitle: dataMap.updateModel.invoiceTitle,
          taxNumber: dataMap.updateModel.taxNumber,
          registeredAddress: dataMap.updateModel.registeredAddress,
          registeredPhone: dataMap.updateModel.registeredPhone,
          bankName: dataMap.updateModel.bankName,
          bankAccount: dataMap.updateModel.bankAccount,
          invoiceType: dataMap.updateModel.invoiceType
        }
        const result = await updateShoppingInvoice(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeShoppingInvoice(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveShoppingInvoice(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.userName = dataMap.editRow.userName
        dataMap.updateModel.invoiceTitle = dataMap.editRow.invoiceTitle
        dataMap.updateModel.taxNumber = dataMap.editRow.taxNumber
        dataMap.updateModel.registeredAddress = dataMap.editRow.registeredAddress
        dataMap.updateModel.registeredPhone = dataMap.editRow.registeredPhone
        dataMap.updateModel.bankName = dataMap.editRow.bankName
        dataMap.updateModel.bankAccount = dataMap.editRow.bankAccount
        dataMap.updateModel.invoiceType = dataMap.editRow.invoiceType
      },
      createReset() {
        console.log('create reset')
      }
    })
    const handleCreate = () => {
      dataMap.dialogStatus = 'create'
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: ShoppingInvoiceModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.userName = row.userName
        dataMap.updateModel.invoiceTitle = row.invoiceTitle
        dataMap.updateModel.taxNumber = row.taxNumber
        dataMap.updateModel.registeredAddress = row.registeredAddress
        dataMap.updateModel.registeredPhone = row.registeredPhone
        dataMap.updateModel.bankName = row.bankName
        dataMap.updateModel.bankAccount = row.bankAccount
        dataMap.updateModel.invoiceType = row.invoiceType
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    onMounted(() => {
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      searchFormRef,
      ...toRefs(dataMap)
    }
  }
})
